import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';

import GiftItem from './GiftItem';
import useProductGiftRecommended from './hooks/useProductGiftRecommended';
import styles from './styles.module.scss';

function ProductGiftRecommend() {
    const data = useProductGiftRecommended();
    return (
        <Column fullWidth align='center' className={styles.container}>
            <Row spacing={18} align='flex-start'
                className={styles.contents}
                fullWidth >
                {data?.items.map((item) => (
                    <GiftItem item={item} key={item.itemId}/>
                ))}
            </Row>
            {data?.title && (
                <Text size='xl' fontWeight='bold' color={colors.gray7}>
                    {data?.title}
                </Text>
            )}
        </Column>
    );
}

export default ProductGiftRecommend;
